import type { CardRef } from "@pra/shared/battle-log";
import type { DecklistDiff } from "@pra/shared/decklist";
import { useCatalog } from "../lib/catalog";

export function DiffView({
  diff,
}: {
  diff: DecklistDiff | { added: CardRef[]; removed: CardRef[]; changed: CardRef[] };
}) {
  const { name } = useCatalog();
  const changed = diff.changed as Array<CardRef & { before?: number; after?: number }>;
  const nothing = diff.added.length === 0 && diff.removed.length === 0 && changed.length === 0;
  if (nothing)
    return (
      <p className="pr-muted" style={{ fontSize: 14 }}>
        No changes.
      </p>
    );
  const plus = [...diff.added, ...changed.filter((c) => c.count > 0)];
  const minus = [...diff.removed, ...changed.filter((c) => c.count < 0)];
  const line = (card: CardRef & { before?: number; after?: number }, sign: "+" | "−") => (
    <li
      key={`${sign}${card.cardId ?? card.name}`}
      className={sign === "+" ? "pr-diff__add" : "pr-diff__rem"}
    >
      {sign}
      {Math.abs(card.count)} {name(card)}
      {card.before !== undefined && card.after !== undefined ? (
        <span className="pr-muted">
          {" "}
          ({card.before} → {card.after})
        </span>
      ) : null}
    </li>
  );
  return (
    <div className="pr-diff">
      <div className="pr-diff__col">
        <h4>Added</h4>
        <ul className="pr-list">
          {plus.length === 0 ? <li className="pr-muted">—</li> : plus.map((c) => line(c, "+"))}
        </ul>
      </div>
      <div className="pr-diff__col">
        <h4>Removed</h4>
        <ul className="pr-list">
          {minus.length === 0 ? <li className="pr-muted">—</li> : minus.map((c) => line(c, "−"))}
        </ul>
      </div>
    </div>
  );
}
